module.exports = __webpack_public_path__ + "img/casa_actriz.a3f81cee.webp";